module.exports = __webpack_public_path__ + "static/media/ic_cc-primary.739d0a20.svg";